// @flow
import * as React from "react";

import { Button, Result } from "antd";

function ApplicationError(): React.Node {
  return (
    <Result
      status="error"
      title="Application error"
      subTitle="Sorry, an unexpected error occurred in the application. We recommend reloading the page."
      extra={
        <>
          <Button color="primary" variant="solid" onClick={() => window.location.reload()}>
            Reload
          </Button>
          <Button color="default" variant="outlined" href="/">
            Back Home
          </Button>
        </>
      }
    />
  );
}

export default ApplicationError;
